// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-info-wrapper{display:flex}@media (max-width: 960px){.user-info-wrapper{flex-direction:column}}\n", ""]);
// Exports
module.exports = exports;
